import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormData, PackageState } from "../../types/packageType";
import { Option } from "../../types/commonElements";

const initialState: PackageState = {
  formData: {
    packageName: "",
    amount: "",
    isGstCollected: false,
  },
  errors: {},
  selectOptions: {
    packageName: [],
  },
  packageTable: [{ no: 0, procedure: "", no_of_session: "", amount: "" }],
  hasUnsavedChanges: false,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormData & { skipUnsavedFlag?: boolean }>) => {
      const { skipUnsavedFlag, ...rest } = action.payload as any;
      state.formData = { ...state.formData, ...rest };
      // Set hasUnsavedChanges to true when form data is modified (unless skipUnsavedFlag is true)
      if (!skipUnsavedFlag) {
        state.hasUnsavedChanges = true;
      }
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setTable: (state, action: PayloadAction<{ rows: any; skipUnsavedFlag?: boolean } | any>) => {
      // Handle both old format (array) and new format (object with rows and skipUnsavedFlag)
      if (Array.isArray(action.payload) || (action.payload && !action.payload.rows)) {
        state.packageTable = action.payload;
        state.hasUnsavedChanges = true;
      } else {
        state.packageTable = action.payload.rows;
        if (!action.payload.skipUnsavedFlag) {
          state.hasUnsavedChanges = true;
        }
      }
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
      state.packageTable = [
        { no: 0, procedure: "", no_of_session: "", amount: "" },
      ];
      state.hasUnsavedChanges = false;
    },
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
    submitForm: (state) => {},
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  submitForm,
  setSelectOptions,
  setTable,
  setHasUnsavedChanges,
} = packageSlice.actions;

export default packageSlice.reducer;
